var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { ImageEntity } from './image-entity';
import { useEntity } from '../../hooks/use-entity';
import { useLink } from '../../hooks/use-link';
import { ContentEntityBlock } from './content-entity-block';
import { first } from 'lodash';
import { classNames } from '../../utils/cn';
var cls = classNames('slice-block-image');
export var SliceBlockImageDefaultProps = {
  showBackground: true,
  contentEntityBlockProps: {}
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    padding-bottom: 1px;\n\n    ", "\n  "], ["\n    display: flex;\n    padding-bottom: 1px;\n\n    ", "\n  "])), function (_a) {
    var center = _a.center;
    return center && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      justify-content: center;\n    "], ["\n      justify-content: center;\n    "])));
  })
});
var BlockStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    width: 100%;\n    max-width: 800px;\n  "], ["\n    margin-bottom: ", ";\n    width: 100%;\n    max-width: 800px;\n  "])), theme.UNIT(10)),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), function (_a) {
    var hasImage = _a.hasImage,
        isReversed = _a.isReversed;
    return hasImage && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      width: 50%;\n    "], ["\n      width: 50%;\n    "])));
  }, function (_a) {
    var hasImage = _a.hasImage,
        isReversed = _a.isReversed;
    return hasImage && isReversed && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      padding-left: ", ";\n    "], ["\n      padding-left: ", ";\n    "])), theme.UNIT(6));
  }, function (_a) {
    var hasImage = _a.hasImage,
        isReversed = _a.isReversed;
    return hasImage && !isReversed && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding-right: ", ";\n    "], ["\n      padding-right: ", ";\n    "])), theme.UNIT(6));
  }),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-bottom: 0;\n  "], ["\n    margin-bottom: 0;\n  "])))
});
var ImageContainerStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 100%;\n  "]))),
  tablet: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    width: 50%;\n  "], ["\n    width: 50%;\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    width: 90%;\n    max-height: 100%;\n  "], ["\n    width: 90%;\n    max-height: 100%;\n  "]))),
  desktop: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    width: 90%;\n    margin-bottom: 0;\n  "], ["\n    width: 90%;\n    margin-bottom: 0;\n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;    \n    align-items: center;\n    justify-content: center;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;    \n    align-items: center;\n    justify-content: center;\n    width: 100%;\n  "]))),
  tablet: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isReversed = _a.isReversed;
    return css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      flex-direction: ", ";\n    "], ["\n      flex-direction: ", ";\n    "])), isReversed ? 'row-reverse' : 'row');
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Block: styled(ContentEntityBlock)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BlockStyles),
  ImageContainer: styled.div.attrs(cls.attr('image-container'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ImageContainerStyles),
  Image: styled(ImageEntity).attrs(cls.attr('image'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Layout: styled.div.attrs(cls.attr('layout'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles)
};
export var SliceBlockImage = function SliceBlockImage(props) {
  var className = props.className,
      children = props.children,
      showBackground = props.showBackground,
      reverse = props.reverse,
      imageHref = props.imageHref,
      contentEntityBlockProps = props.contentEntityBlockProps,
      rest = __rest(props, ["className", "children", "showBackground", "reverse", "imageHref", "contentEntityBlockProps"]);

  var entity = useEntity(props.entity);
  var images = entity.images;
  var image = first(images);
  var Link = useLink().Link;
  var imageElement = image && React.createElement(My.Image, {
    entity: image
  });
  var center = contentEntityBlockProps.center === undefined ? !imageElement : contentEntityBlockProps.center;
  return React.createElement(My.Container, __assign({
    center: center
  }, rest, {
    className: cls.name(className)
  }), React.createElement(My.Layout, {
    center: center,
    isReversed: reverse
  }, React.createElement(My.Block, __assign({
    isReversed: reverse
  }, __assign(__assign({}, contentEntityBlockProps), {
    center: center
  }), {
    entity: entity,
    hasImage: !!image
  })), image && React.createElement(My.ImageContainer, null, imageHref ? React.createElement(Link, {
    style: {
      width: "90%"
    },
    href: imageHref
  }, imageElement) : imageElement)), children);
};
SliceBlockImage.defaultProps = SliceBlockImageDefaultProps;
SliceBlockImage.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;